const SHIPPING_METHOD_KEY_PARCEL = 'parcel';
const SHIPPING_METHOD_KEY_FREIGHT = 'freight';
const SHIPPING_METHOD_KEY_DEFAULT = SHIPPING_METHOD_KEY_PARCEL;

module.exports = {
  SHIPPING_METHOD_KEY_PARCEL,
  SHIPPING_METHOD_KEY_FREIGHT,
  SHIPPING_METHOD_KEY_DEFAULT,
};
